import React from 'react';
import { FIELD_TYPES } from './constants/formConstants';

export const FieldLabel = ({ field, theme }) => {
  if (field.type === FIELD_TYPES.CHECKBOX || !field.name) return null;
  
  return (
    <label htmlFor={field.id} className={theme.label}>
      {field.name}
      {field.validation?.required && <span className="text-red-500 ml-1">*</span>}
    </label>
  );
};